/* these paths need special process when reaching out to search */
export const HDM_CATALOG_SEO_PATHS = {
	Product: 'p',
	Category: 'b',
	Bundle: 'g',
};

/* these paths are seo paths but no need to process before reaching search */
export const HDM_SEARCH_SEO_PATHS = {
	Search: 's',
};

export const HDM_URLS_PAGE_PATHS = {
	ItemPage: '/p/',
	KitPage: '/p/',
	BundlePage: '/g/',
	CategoryPage: '/b/',
	ProductListPage: '/b/',
	SearchListPage: '/s/',
};

export const HDM_ACCOUNT_PATHS = {
	Account: 'account',
};
